import React, { useState, useRef } from 'react';
import Button from '@dtci/spellbook/Button';

export default function NameCellEditor(props) {
    const [value, setValue] = useState(props.value);
    const originalValue = useRef(props.value);

    // Handle input change with alphanumeric validation (letters, numbers, and spaces only)
    const handleInputChange = (event) => {
        const regex = /^[a-zA-Z0-9\s]*$/;
        const inputValue = event && event.target ? event.target.value : '';
        if (regex.test(inputValue)) {
            setValue(inputValue);
        }
    };

    const onSave = async () => {
        try {
            await props.context.onSave(value, props.node.data);
            props.stopEditing();
        } catch (err) {
            setValue(originalValue.current);
            props.stopEditing(true);
        }
    };

    const onCancel = () => {
        setValue(originalValue.current);
        props.stopEditing(true);
    };

    return (
        <span
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                maxWidth: '100%',
                flexWrap: 'wrap',
                overflow: 'hidden'
            }}
        >
            <input
                value={value}
                onChange={handleInputChange}
                maxLength={30}
                style={{ marginRight: 8, minWidth: 0, flex: 1 }}
            />
            <Button
                iconType="fa-solid fa-save"
                sizeType="small"
                styleType="link"
                onClick={onSave}
            />
             <Button
                 iconType="fa-solid fa-xmark"
                 sizeType="small"
                 styleType="link"
                 onClick={onCancel}
                 style={{ color: 'var(--sbt-red-60, #d32f2f)' }}
             />
        </span>
    );
}